import axios from 'axios';

/**
 * standard unaltered axios instance.
 */
export default axios.create();




// WEBPACK FOOTER //
// ./src/services/dataSources/default.js